import React, { ReactElement } from 'react';
import classnames from 'classnames';

export interface RawStep {
  title: string;
  description?: string;
  StepContent?: ReactElement | ReactElement[];
  isActive?: boolean;
}

interface StepProps extends RawStep {
  index: number;
  isLast: boolean;
}

export function StepComponent({ title, description, index, isLast, isActive, StepContent }: StepProps): ReactElement {
  return (
    <div className={classnames('step-component__container', { active: isActive })}>
      {!isLast && <div className="step-component__progress-line"></div>}
      <div className="step-component__order-label">{index}</div>
      <div className="step-component__text-container">
        <div className="step-component__title-label">{title}</div>
        <div className="step-component__description">{description}</div>
      </div>
      <div className="step-component__step-content">{StepContent}</div>
    </div>
  );
}
